import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function MonitorIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M13.3333 2H2.66665C1.93027 2 1.33331 2.59695 1.33331 3.33333V10C1.33331 10.7364 1.93027 11.3333 2.66665 11.3333H13.3333C14.0697 11.3333 14.6666 10.7364 14.6666 10V3.33333C14.6666 2.59695 14.0697 2 13.3333 2Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33331 14H10.6666"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.3333V13.9999"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default MonitorIcon;
